export default __webpack_public_path__ + "static/press-awards-omaha-2026-a9859f9f8741d41e1103e6e45f076a7b.webp";